import React, { memo, useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import historyHandler from 'jd-library/historyHandler';
import styles from './Styles/export-history.scss';
import ImportExportFileProgress from './ImportExportFileProgress';
import Loader from '../../../../common/Loader/Loader';
import NoProductFound from '../../../../common/no-product-found/NoProductFound';

function BulkUpdateHistory(props) {
  const [data, setData] = useState(() => null);
  const [isLoading, setLoading] = useState(() => true);
  const [sliderContRef, setSliderContRef] = useState(() => null);
  const tabKey = useSelector((state) => state.products.tabKey);

  const leftIcons = [
    {
      className: 'icon-HDRback',
      onClick: () => {
        props.setCurrentStep();
        window.history.back();
      }
    }
  ];
  const rightIcons = [
    {
      className: 'icon-HDRcross',
      onClick: () => {
        props.onHidden();
        historyHandler.closeAll();
      }
    }
  ];
  const [isFetching, setIsFetching] = useInfiniteScroll({
    scrollContainer: sliderContRef,
    loadMoreCB: () => {
      if (!data?.islastPage && data?.nextPage) {
        let params = {
          supplierId: props?.supplierId,
          currentPage: data?.currentpageNo + 1,
          pageSize: 10,
          logFor: 'INVENTORIES'
        }
        axios.get('/vendorapis/products/inventory/getImportInventoryLogs', {
          params
        }).then(res => {
          if (res.data.isError === false) {
            setData(() => ({
              ...res.data.data,
              results: [...data?.results, ...res.data.data?.results]
            }));
            setIsFetching(() => false);
          }
        })
      }
    },
    useWindow: false,
    threshold: 500,
    deps: [sliderContRef]
  });

  useEffect(() => {
    let params = {
      supplierId: props?.supplierId,
      currentPage: 1,
      pageSize: 10,
      logFor: 'INVENTORIES',
    }
    axios.get('/vendorapis/products/inventory/getImportInventoryLogs', {
      params
    }).then(res => {
      setLoading(() => false);
      if (res.data.isError === false) {
        setData(() => ({ ...res.data.data }));
      }
    })
  }, []);


  return (
    <SliderWrapper
      updateScrollContRef={ref => {
        setSliderContRef(ref);
      }}
      header={{
        heading: 'Bulk Update History',
        leftIcons,
        rightIcons
      }}
      onHidden={() => props.onHidden()}
    >
      {isLoading ? <Loader /> :
        <div className={styles['export-history']}>
          {data?.results?.length ?
            data?.results?.map((item) => (
              <ImportExportFileProgress
                key={item.id}
                item={item}
                activeTab={tabKey}
              />
            ))
            : (<NoProductFound
              label="No Bulk Update History"
            />)}
        </div>
      }
    </SliderWrapper>
  );
}

export default memo(BulkUpdateHistory);